<template>
  <section id="section__documents">
    <p class="font--p-3 mt-5 mb-5">필요 서류를 제출해주세요</p>

    <div v-for="(v, k) in requireDocuments" class="documents-items" :key="k + '_uploader'">
      <v-card class="doc-uploader__activator">
        <v-card-text class="py-5">
          <DocumentFileUploader
            :documentKey="k"
            :label="v.title"
            :originFilePath="v.originPath"
            :disabled="contractCurrent?.status === 'started'"
            :document.sync="v.file"
          />
        </v-card-text>
      </v-card>
    </div>

    <BasicButton :disabled="!isBusinessLicenseNotNull" :to="{ path: '/bank/collections' }">
      파일 제출 완료
    </BasicButton>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DocumentFileUploader from '@/components/documents/DocumentFileUploader.vue'

export default {
  components: {
    DocumentFileUploader,
  },
  data() {
    return {
      requireDocuments: {
        businessLicense: { title: '사업자등록증', file: null, originPath: null },
        bankbook: { title: '통장사본', file: null, originPath: null },
        certificateOfIncomeAmount: { title: '소득금액증명원', file: null, originPath: null },
      },
      documents: null,
    }
  },
  computed: {
    ...mapState('contract', {
      contractCurrent: 'current',
    }),
    isNext() {
      const hasAll = Object.keys(this.requireDocuments).every((rq) => {
        const doc = this.requireDocuments[rq]
        return !!doc.file || !!doc.originPath
      })
      return hasAll
    },
    isBusinessLicenseNotNull() {
      return (
        !!this.requireDocuments.businessLicense.file ||
        !!this.requireDocuments.businessLicense.originPath
      )
    },
  },
  async created() {
    _meta({
      titles: ['필요서류제출'],
    })
    this.getDocuments()
  },
  watch: {
    documents(v) {
      for (const k in v) {
        if (this.requireDocuments[k]) {
          this.requireDocuments[k].originPath = v[k]
        }
      }
    },
  },
  methods: {
    ...mapActions('document', {
      getStoreDocuments: 'getDocuments',
    }),
    async getDocuments() {
      this.documents = await this.getStoreDocuments()
    },
  },
}
</script>

<style lang="scss" scoped>
.documents-items {
  margin-bottom: 15px;
}
</style>
